import { useCallback, useEffect, useState } from 'react';
import {
    DESKTOP, PRESET_NAMES, PRESETS,
} from './presets';

const LS_KEY = 'hsh.dashboard.preset';

function readStored() {
    try {
        const raw = window.localStorage.getItem(LS_KEY);
        if (raw && PRESET_NAMES.includes(raw)) return raw;
    } catch (_err) {
        // localStorage unavailable (private mode, SSR) — fall through.
    }
    return null;
}

function writeStored(name) {
    try {
        window.localStorage.setItem(LS_KEY, name);
    } catch (_err) {
        // ignored — preset still drives the UI for this session.
    }
}

// useDashboardPreset returns [presetName, setPresetName].
//
// First mount: try localStorage; if absent, default to DESKTOP.
// The picker is the only way a preset gets selected — no viewport
// auto-detect.
//
// setPresetName persists to localStorage on every change.
export function useDashboardPreset() {
    const [presetName, setPresetNameInternal] = useState(() => {
        const stored = readStored();
        if (stored) return stored;
        return DESKTOP;
    });

    const setPresetName = useCallback((name) => {
        if (!PRESETS[name]) return;
        setPresetNameInternal(name);
        writeStored(name);
    }, []);

    useEffect(() => {
        // Persist the default on first mount so a subsequent reload
        // keeps the same preset.
        if (!readStored()) writeStored(presetName);
    }, [presetName]);

    return [presetName, setPresetName];
}
